import React from 'react';
import { getGroupProspectList } from 'api/group';
import { Prospect } from 'types/common';

const useAllGroupProspectList = (enabled: boolean = true): [Prospect[], boolean, () => void] => {
    const [data, setData] = React.useState<Prospect[]>([]);
    const loading = React.useRef(false);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getGroupProspectList({ pageNo: 1, pageSize: 3000 });

            if (!result.error) {
                const _data = result?.data?.data?.list || result?.data?.data?.records || result?.data?.data || [];
                setData(Array.isArray(_data) ? _data : []);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (enabled && !loading.current) {
            fetchData();
        }
    }, [enabled]);

    return [data, loading.current, fetchData];
};

export default useAllGroupProspectList;
